import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import ConfirmationPage from './Confirmation';
import StepEdp from './Edp/StepEdp';
import StepGfl from './Gfl/StepGfl';
import Header from './header/Header';
import Footer from './Footer/Footer';
import { Toaster } from 'react-hot-toast';

const Form = () => {

    const [step, setStep] = useState(1);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const key = queryParams.get('token');
    const [token, setToken] = useState(key);
    const [formData, setFormData] = useState({token});
    const [Mydata, setMydata] = useState(null);
    const [no_immatriculation, setImmatriculation] = useState('');
    const [fichiers, setFichiers] = useState([]);
    const [isFormSubmitted, setFormSubmitted] = useState(false);

    const handleNext = (data) => {
        setFormData((prevData) => ({...prevData, ...data}));
        setStep((prevStep) => prevStep + 1);
        window.scrollTo(0, 0);
    };

    const handlePrevious = () => {
        setStep((prevStep) => prevStep - 1);
    };

    const envoiDevis = (files) => {
        setFichiers(files);
    };

    const handleFinalSubmit = async (stepData) => {
        const finalData = {...formData, ...stepData};

        setFormData(finalData);
        setFormSubmitted(true);

        try {
            await fetch('api/v1/societaire', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(stepData)

            });

            const donnee = new FormData();

            if (finalData.locationDoc !== null && finalData.ribDoc !== null && finalData.sinistreDoc !== null) {
                let updatedFiles = fichiers.concat(finalData.locationDoc).concat(finalData.ribDoc).concat(finalData.sinistreDoc);
                for (const element of updatedFiles) {
                    donnee.append('devis[]', element);
                }
            } else {
                for (const element of fichiers) {
                    donnee.append('devis[]', element);
                }
            }

            await fetch('/api/v1/devis', {
                method: 'POST',
                headers: {
                    'token': `${token}`
                },
                body: donnee
            });
        } catch (error) {
            console.error('Erreur lors de la soumission des données:', error);
        }


    };
    useEffect(() => {
        if (!key) {
            setToken(null);
        }
        setToken(key);
        fetch(`/api/v1/societaire/${encodeURIComponent(token)}`)
            .then((res) => res.json())
            .then((data) => {
                setImmatriculation(data['no_immatriculation']);
                setMydata(data);
            }).catch((err) => {
            console.error(err);
        });
    }, [key, location, token]);

    if (!token) {
        return <NotFoundPage/>;
    }

    if (isFormSubmitted) {
        return <ConfirmationPage/>;
    }

    const switchFormulaire = () => {
        return (
            <div>
                {(() => {
                    switch (Mydata?.code_prestation) {
                        case 'EDP_MACIF':
                            return (
                                <div>
                                    <Header titre={'Service Etude devis suite à panne'}/>
                                    <StepEdp
                                        Mydata={Mydata}
                                        step={step}
                                        formData={formData}
                                        setFormData={setFormData}
                                        handleNext={handleNext}
                                        handlePrevious={handlePrevious}
                                        token={token}
                                        envoiDevis={envoiDevis}
                                        handleFinalSubmit={handleFinalSubmit}
                                        no_immatriculation={no_immatriculation}
                                    />
                                    <Footer/>
                                </div>
                            );
                        case 'GFL_MACIF':
                            return (
                                <div >
                                    <Header titre={'Service Garantie Franchise de location'}/>
                                    <StepGfl
                                        Mydata={Mydata}
                                        step={step}
                                        formData={formData}
                                        setFormData={setFormData}
                                        handleNext={handleNext}
                                        handlePrevious={handlePrevious}
                                        token={token}
                                        handleFinalSubmit={handleFinalSubmit}
                                        no_immatriculation={no_immatriculation}
                                    />
                                    <Footer/>
                                </div>
                            );
                        default:
                            return <NotFoundPage/>;
                    }
                })()}
                <Toaster />
            </div>
        );
    };

    return (
        <div>
            {switchFormulaire()}
        </div>
    );

};

export default Form;